import type { EmbedBlockContent } from "../types"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Card, CardContent, CardHeader } from "@/components/ui/card"

interface EmbedBlockEditorProps {
  content: EmbedBlockContent | null
  onChange: (content: EmbedBlockContent) => void
}

export function EmbedBlockEditor({ content, onChange }: EmbedBlockEditorProps) {
  const c = content ?? {}
  const update = (partial: Partial<EmbedBlockContent>) =>
    onChange({ ...c, ...partial })

  return (
    <Card>
      <CardHeader>
        <h3 className="text-base font-medium">Embed</h3>
        <p className="text-sm text-muted-foreground">
          Embed iframe content. Only https:// URLs are rendered.
        </p>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <Label>Embed URL</Label>
          <Input
            value={c.url ?? ""}
            onChange={(e) => update({ url: e.target.value })}
            placeholder="https://..."
          />
        </div>
        <div>
          <Label>Title (optional)</Label>
          <Input
            value={c.title ?? ""}
            onChange={(e) => update({ title: e.target.value })}
            placeholder="Embed title"
          />
        </div>
        <div>
          <Label>Height</Label>
          <Input
            type="number"
            min={100}
            value={c.height ?? 400}
            onChange={(e) => update({ height: Number(e.target.value) || 400 })}
            placeholder="400"
          />
        </div>
      </CardContent>
    </Card>
  )
}
